module.exports = __webpack_public_path__ + "e35c4f89247b5f234214015c0add622d.MP3";